import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import axios from 'axios';

/**
 * Loads the pharmacy's AR feature flag for a page that is useless without it.
 *
 * The flag is deliberately tri-state. Collapsing a failed lookup into "disabled" tells the user
 * their pharmacy is not set up for AR when the real cause is a transient API failure, and there is
 * nothing on screen to retry. `null` keeps "we could not find out" distinct from "off".
 */
@Component
export default class AREnabledMixin extends Vue {
    /** true = on, false = off, null = the lookup has not completed or failed. */
    protected arEnabled: boolean | null = null;
    // Starts true, not false: Vue renders once before mounted() runs and every consumer starts the
    // lookup from mounted, so a false here makes arConfigUnavailable true on the first paint and
    // flashes the failure message before the spinner ever appears.
    protected arConfigLoading = true;

    protected get arConfigUnavailable(): boolean {
        return !this.arConfigLoading && this.arEnabled === null;
    }

    protected get arDisabled(): boolean {
        return this.arEnabled === false;
    }

    protected async loadArEnabled(): Promise<void> {
        try {
            this.arConfigLoading = true;
            const response = await axios.get<boolean>('/configuration/enableAR');
            this.arEnabled = response.data === true;
        } catch {
            this.arEnabled = null;
        } finally {
            this.arConfigLoading = false;
        }
    }
}
